import { nanoid } from "nanoid";
import { v4 as uuid } from "uuid";

export const makeNodeId = (isTopLevel: boolean) =>
  isTopLevel ? uuid() : nanoid(16);
